import {
  CustomButton,
  CustomCollapseCard,
  CustomForm,
  CustomFormItem,
  CustomImage,
  CustomInput,
  CustomSelect,
  successDialog,
  Option,
  Text,
  useText,
} from '@src/components';
import '@src/styles/companyInformation/generalCompanyInformation/generalCompanyInformation.scss';
import iconInfo from '@src/assets/icons/icon-bilgi.svg';
import { Alert, Form, Input } from 'antd';
import React, { useCallback, useEffect, useState } from 'react';
import { turkishToLower } from '@src/utils/utils';
import { useDispatch, useSelector } from 'react-redux';
import {
  cityGetAll,
  countyGetAll,
  neighborhoodGetAll,
  setNeighborhoodList,
} from '@src/store/slice/lookupSlice';
import warning from '@src/assets/icons/icon-profil-warning.svg';
import { formMailRegex } from '@src/utils/formRule';
import FormModal from './FormModal';
import {
  getCompanyList,
  updateCompanyInfos,
  resetResponse,
} from '@src/store/slice/companyInfosSlice';

const { TextArea } = Input;

const GeneralCompanyInformationForm = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { cityList, countyList, neighborhoodList } = useSelector((state) => state?.lookup);
  const { companyInfoList, response } = useSelector((state) => state?.companyInfos);

  const [isModal, setIsModal] = useState(false);
  const [modalType, setModalType] = useState({});

  const yourTransactionHasBeenSuccessfullyCompleted = useText('yourTransactionHasBeenSuccessfullyCompleted');
  const transactionSuccessfullyCompleted2 = useText('transactionSuccessfullyCompleted2');
  useEffect(() => {
    dispatch(getCompanyList());
  }, []);

  useEffect(() => {
    if(!response)return ;
    if (Object.keys(response)?.length) {
      if (response?.isSuccess) {
        successDialog({
          title: <Text t="success" />,
          message: yourTransactionHasBeenSuccessfullyCompleted,
          onOk: () => {
            dispatch(getCompanyList());
          },
        });
      }
      return dispatch(resetResponse());
    }
  }, [response]);

  useEffect(() => {
    form.setFieldsValue({
      invoiceAddress: companyInfoList[0]?.detail,
      cityId: companyInfoList[0]?.cityId,
      countyId: companyInfoList[0]?.countyName,
      neighborhoodId: companyInfoList[0]?.neighborhoodName,
    });
  }, [companyInfoList]);

  useEffect(() => {
    if (cityList?.length === 0) {
      dispatch(cityGetAll());
    }
  }, [cityList?.length, dispatch]);

  const cityChange = useCallback(
    async (cityId) => {
      try {
        dispatch(countyGetAll(cityId));
        dispatch(setNeighborhoodList([]));
        form.resetFields(['countyId', 'neighborhoodId']);
      } catch (e) {}
    },
    [dispatch],
  );

  const countyChange = useCallback(
    async (countyId) => {
      try {
        dispatch(neighborhoodGetAll(countyId));
        form.resetFields(['neighborhoodId']);
      } catch (e) {}
    },
    [dispatch],
  );

  const handleModal = useCallback((record, type) => {
    let body = {
      ...record,
      type: type,
    };
    setModalType(body);
    setIsModal(true);
  }, []);

  const handleSave = useCallback(async () => {
    try {
      const values = await form.validateFields();
      if (typeof values?.countyId === 'string') {
        values.countyId = companyInfoList[0]?.countyID;
      }

      if (typeof values?.neighborhoodId === 'string') {
        values.neighborhoodId = companyInfoList[0]?.neighborhoodId;
      }

      if (!values?.eArchiveMail) {
        values.eArchiveMail = companyInfoList[0]?.eArchiveMail;
      }
      const data = {
        ...values,
        taxNumber: companyInfoList[0]?.taxNumber,
        taxOffice: companyInfoList[0]?.taxOffice,
      };
      const updateInfoResponse = await dispatch(updateCompanyInfos(data));
      if(updateCompanyInfos.fulfilled.match(updateInfoResponse)){
        successDialog({
          title: <Text t="success" />,
          message: transactionSuccessfullyCompleted2,
          onOk: () => {
            dispatch(getCompanyList());
          },
        });
      }
    } catch (e) {}
  }, [form, companyInfoList, dispatch]);

  const customerNameDocumentList = [
    {
      value: 3,
      text: <Text t="tradeRegistryGazette" />,
    },
    {
      value: 5,
      text: <Text t="taxBoard" />,
    },
  ];

  const taxNumberDocumentList = [
    {
      value: 0,
      text: <Text t="singnatureCircular" />,
    },
    {
      value: 3,
      text: <Text t="tradeRegistryGazette" />,
    },
    {
      value: 5,
      text: <Text t="taxBoard" />,
    },
    {
      value: 1,
      text: <Text t="copyOfIdentityCard" />,
    },
    {
      value: 2,
      text: <Text t="creditCardInstruction" />,
    },
    {
      value: 4,
      text: <Text t="ticketRestaurantCardAgreement" />,
    },
  ];

  const taxOfficeDocumentList = [
    {
      value: 5,
      text: <Text t="taxBoard" />,
    },
  ];

  const handleInvoiceTitleChange = useCallback(() => {
    const record = {
      title: <Text t="invoiceTitleChange" />,
      label: <Text t="invoiceTitle2" />,
      value: companyInfoList[0]?.name,
      fieldType: 0,
      companyInfoId: companyInfoList[0]?.id,
      documentList: customerNameDocumentList,
    };
    handleModal(record, 1);
  }, [companyInfoList, handleModal]);

  const handleTaxNumberChange = useCallback(() => {
    const record = {
      title: <Text t="taxNumberAndIdentityNumber" />,
      label: <Text t="taxNumberTcIdNo2" />,
      value: companyInfoList[0]?.taxNumber,
      fieldType: 1,
      companyInfoId: companyInfoList[0]?.id,
      documentList: taxNumberDocumentList,
    };
    handleModal(record, 2);
  }, [companyInfoList, handleModal]);

  const handleTaxOfficeChange = useCallback(() => {
    const record = {
      title: <Text t="changeTaxOffice" />,
      label: <Text t="taxOffice2" />,
      value: companyInfoList[0]?.taxOffice,
      fieldType: 2,
      companyInfoId: companyInfoList[0]?.id,
      documentList: taxOfficeDocumentList,
    };
    handleModal(record, 3);
  }, [companyInfoList, handleModal]);

  return (
    <CustomCollapseCard
      className="delivery-adresses-filter-card"
      cardTitle={<Text t="generalCompanyInformation" />}
    >
      <CustomForm
        name="companyForm"
        className="company-form"
        autoComplete="off"
        initialValues={{}}
        layout={'horizontal'}
        form={form}
      >
        <div className="info-content">
          <div className="info-text-item">
            <span className="info-title">
              <Text t="invoiceTitle" />
            </span>
            <div>
              {companyInfoList[0]?.name}
              <button
                type="button"
                className="modal-btn"
                style={{ backgroundColor: 'transparent', border: 'none' }}
                onClick={handleInvoiceTitleChange}
              >
                <Text t="change" />
              </button>
            </div>
          </div>

          <div className="info-text-item">
            <span className="info-title">
              <Text t="taxNumberTcIdNo" />
            </span>
            <div>
              {companyInfoList[0]?.taxNumber}
              <CustomImage className="icon-search" src={iconInfo} />
              <button
                type="button"
                className="modal-btn"
                style={{ backgroundColor: 'transparent', border: 'none' }}
                onClick={handleTaxNumberChange}
              >
                <Text t="change" />
              </button>
            </div>
          </div>
          <div className="info-text-item">
            <span className="info-title">
              <Text t="taxOffice" />
            </span>
            <div>
              {companyInfoList[0]?.taxOffice}
              <button
                type="button"
                className="modal-btn"
                style={{ backgroundColor: 'transparent', border: 'none' }}
                onClick={handleTaxOfficeChange}
              >
                <Text t="change" />
              </button>
            </div>
          </div>

          <CustomFormItem
            label={<Text t="invoiceAddress" />}
            name="invoiceAddress"
            className={'delivery-address-add-form-item'}
            rules={[{ required: true, message: <Text t="requiredField2" /> }]}
          >
            <TextArea
              id="companyInformation-generalCompanyInformation-generalCompanyInformationForm-invoiceAddress-textArea"
              rows={3}
            />
          </CustomFormItem>

          <div className="form-item">
            <CustomFormItem
              label={
                <div>
                  <Text t="province" />
                  <span>:</span>
                </div>
              }
              name="cityId"
              className={'delivery-address-city-form-item'}
              rules={[{ required: true, message: <Text t="requiredField2" /> }]}
            >
              <CustomSelect
                id="companyInformation-generalCompanyInformation-generalCompanyInformationForm-cityId-select"
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  turkishToLower(option.children).includes(turkishToLower(input))
                }
                placeholder={useText('choose')}
                onChange={cityChange}
                height={36}
              >
                {cityList.map((item) => {
                  return (
                    <Option
                      id={`companyInformation-generalCompanyInformation-generalCompanyInformationForm-cityId-${item?.name}-option`}
                      key={item?.id}
                      value={item?.id}
                    >
                      {item?.name}
                    </Option>
                  );
                })}
              </CustomSelect>
            </CustomFormItem>

            <CustomFormItem
              label={
                <div>
                  <Text t="district" />
                  <span>:</span>
                </div>
              }
              name="countyId"
              className={'delivery-address-county-form-item'}
              rules={[{ required: true, message: <Text t="requiredField2" /> }]}
            >
              <CustomSelect
                id="companyInformation-generalCompanyInformation-generalCompanyInformationForm-countyId-select"
                placeholder={useText('choose')}
                disabled={countyList.length === 0}
                onChange={countyChange}
                height={36}
              >
                {countyList.map((item) => {
                  return (
                    <Option
                      id={`companyInformation-generalCompanyInformation-generalCompanyInformationForm-countyId-${item?.name}-option`}
                      key={item?.id}
                      value={item?.id}
                    >
                      {item?.name}
                    </Option>
                  );
                })}
              </CustomSelect>
            </CustomFormItem>

            <CustomFormItem
              label={
                <div>
                  <Text t="district2" />
                  <span>:</span>
                </div>
              }
              name="neighborhoodId"
              className={'delivery-address-neighborhoodId-form-item'}
              rules={[{ required: true, message: <Text t="requiredField2" /> }]}
            >
              <CustomSelect
                id="companyInformation-generalCompanyInformation-generalCompanyInformationForm-neighborhoodId-select"
                placeholder={useText('choose')}
                disabled={neighborhoodList.length === 0}
                height={36}
              >
                {neighborhoodList.map((item) => {
                  return (
                    <Option
                      id={`companyInformation-generalCompanyInformation-generalCompanyInformationForm-neighborhoodId-${item?.name}-option`}
                      key={item?.id}
                      value={item?.id}
                    >
                      {item?.name}
                    </Option>
                  );
                })}
              </CustomSelect>
            </CustomFormItem>
          </div>
        </div>

        <div className="e-archive-content">
          <div className="e-archive-info-content">
            <h5>
              <Text t="eArchieve" />
            </h5>
            <p>
              <Text t="dearCustomer" />
            </p>
            <p>
              {' '}
              <Text t="asPreviouslyNotifiedToYouOurCompanyHas" />
            </p>
          </div>

          <Alert
            message={
              <div className="alert-message-contain">
                <CustomImage src={warning} />{' '}
                <div className="message-content">
                  <span>
                    <Text t="pleaseNote" />
                  </span>
                  <Text t="afterRegisteringYourEMailAddressYouCan" />
                </div>
              </div>
            }
            banner
            showIcon={false}
            className="custom-alert-warning"
          />

          <div className="e-archive-form-content">
            <p>
              <Text t="yourPreviouslyDefinedEMailAddress" />{' '}
              <span>{companyInfoList[0]?.eArchiveMail}</span>
            </p>

            <CustomFormItem
              label={
                <div>
                  <Text t="emailAdress" />
                  <span>:</span>
                </div>
              }
              name="eArchiveMail"
              className="email-form-item"
              rules={[{ validator: formMailRegex, message: <Text t="enterValidEmail" /> }]}
            >
              <CustomInput
                id="companyInformation-generalCompanyInformation-generalCompanyInformationForm-eArchiveMail-input"
                height={36}
              />
            </CustomFormItem>

            <div className="action-btn-content">
              <CustomButton
                id="companyInformation-generalCompanyInformation-generalCompanyInformationForm-save-btn"
                className="save-btn"
                onClick={handleSave}
              >
                <Text t="approve2" />
              </CustomButton>
            </div>
          </div>
        </div>
      </CustomForm>
      <FormModal modalVisible={isModal} handleModalVisible={setIsModal} modalType={modalType} />
    </CustomCollapseCard>
  );
};

export default GeneralCompanyInformationForm;
